import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';

export class FinanceReportsCreateDto extends BaseModel {
  @Expose()
  name!: string;
}

export class FinanceReportsUpdateDto extends BaseModel {
  @Expose()
  name!: string;
}
